__turbopack_context__.v({
  "bgImage": "fXiCDG_bgImage",
  "bgImage2": "fXiCDG_bgImage2",
  "button___0VyIw": "fXiCDG_button___0VyIw",
  "button___5Ctym": "fXiCDG_button___5Ctym",
  "button___9Lpr": "fXiCDG_button___9Lpr",
  "button__kW4Ki": "fXiCDG_button__kW4Ki",
  "button__o2Knj": "fXiCDG_button__o2Knj",
  "button__rrZyv": "fXiCDG_button__rrZyv",
  "button__sl1Db": "fXiCDG_button__sl1Db",
  "button__wIMtU": "fXiCDG_button__wIMtU",
  "button__ws1Ys": "fXiCDG_button__ws1Ys",
  "cardHeader": "fXiCDG_cardHeader",
  "cardHeader2": "fXiCDG_cardHeader2",
  "cardHeader3": "fXiCDG_cardHeader3",
  "cardHeader4": "fXiCDG_cardHeader4",
  "cardHeader5": "fXiCDG_cardHeader5",
  "cardHeader6": "fXiCDG_cardHeader6",
  "cardHeader7": "fXiCDG_cardHeader7",
  "cardHeader8": "fXiCDG_cardHeader8",
  "cardHeader9": "fXiCDG_cardHeader9",
  "cards": "fXiCDG_cards",
  "cards2": "fXiCDG_cards2",
  "cards3": "fXiCDG_cards3",
  "col": "fXiCDG_col",
  "col2": "fXiCDG_col2",
  "content": "fXiCDG_content",
  "content2": "fXiCDG_content2",
  "content3": "fXiCDG_content3",
  "content4": "fXiCDG_content4",
  "content5": "fXiCDG_content5",
  "content6": "fXiCDG_content6",
  "content7": "fXiCDG_content7",
  "content8": "fXiCDG_content8",
  "content9": "fXiCDG_content9",
  "desktop": "fXiCDG_desktop",
  "freeBox": "fXiCDG_freeBox",
  "graduateCard": "fXiCDG_graduateCard",
  "graduateCard2": "fXiCDG_graduateCard2",
  "graduateCard3": "fXiCDG_graduateCard3",
  "icon": "fXiCDG_icon",
  "icon2": "fXiCDG_icon2",
  "icon3": "fXiCDG_icon3",
  "icon4": "fXiCDG_icon4",
  "icon5": "fXiCDG_icon5",
  "icon6": "fXiCDG_icon6",
  "icon7": "fXiCDG_icon7",
  "icon8": "fXiCDG_icon8",
  "icon9": "fXiCDG_icon9",
  "mobile": "fXiCDG_mobile",
  "nursingCard": "fXiCDG_nursingCard",
  "nursingCard2": "fXiCDG_nursingCard2",
  "nursingCard3": "fXiCDG_nursingCard3",
  "physicianCard": "fXiCDG_physicianCard",
  "physicianCard2": "fXiCDG_physicianCard2",
  "physicianCard3": "fXiCDG_physicianCard3",
  "row": "fXiCDG_row",
  "row2": "fXiCDG_row2",
  "sectionHeader__mevV7": "fXiCDG_sectionHeader__mevV7",
  "sectionHeader__oaNpk": "fXiCDG_sectionHeader__oaNpk",
  "sectionHeader__yIvH6": "fXiCDG_sectionHeader__yIvH6",
  "solutions": "fXiCDG_solutions",
  "svg___3FaNp": "fXiCDG_svg___3FaNp",
  "svg__anIjJ": "fXiCDG_svg__anIjJ",
  "svg__c8URp": "fXiCDG_svg__c8URp",
  "svg__f5Hq3": "fXiCDG_svg__f5Hq3",
  "svg__flkUm": "fXiCDG_svg__flkUm",
  "svg__lw7Vh": "fXiCDG_svg__lw7Vh",
  "svg__mblR8": "fXiCDG_svg__mblR8",
  "svg__pJ20Q": "fXiCDG_svg__pJ20Q",
  "svg__qp4Zt": "fXiCDG_svg__qp4Zt",
  "svg__tWiT": "fXiCDG_svg__tWiT",
  "svg__twQqx": "fXiCDG_svg__twQqx",
  "svg__txksC": "fXiCDG_svg__txksC",
  "svg__vDLxv": "fXiCDG_svg__vDLxv",
  "svg__yE1R": "fXiCDG_svg__yE1R",
  "svg__yYDg": "fXiCDG_svg__yYDg",
  "svg__zKnRp": "fXiCDG_svg__zKnRp",
  "svg__zckz4": "fXiCDG_svg__zckz4",
  "svg__zsiAh": "fXiCDG_svg__zsiAh",
  "tablet": "fXiCDG_tablet",
  "text": "fXiCDG_text",
  "text2": "fXiCDG_text2",
  "text3": "fXiCDG_text3",
  "text4": "fXiCDG_text4",
  "text5": "fXiCDG_text5",
  "text6": "fXiCDG_text6",
  "text7": "fXiCDG_text7",
  "text8": "fXiCDG_text8",
  "text9": "fXiCDG_text9",
  "title": "fXiCDG_title",
  "title2": "fXiCDG_title2",
  "title3": "fXiCDG_title3",
  "title4": "fXiCDG_title4",
  "title5": "fXiCDG_title5",
  "title6": "fXiCDG_title6",
  "title7": "fXiCDG_title7",
  "title8": "fXiCDG_title8",
  "title9": "fXiCDG_title9",
  "wrapper": "fXiCDG_wrapper",
  "wrapper2": "fXiCDG_wrapper2",
});
